import { h, render } from 'preact';

import { Menu } from './components/Menu';
import { MobileMenu } from './components/MobileMenu';

export const initMenu = (): void => {
    render(h(Menu, window.menuState), document.querySelector('.menu-root'));
    render(h(MobileMenu, window.menuState), document.querySelector('.mobile-menu-root'));
};
